import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-techniques',
  templateUrl: './error-techniques.component.html',
  styleUrls: ['./error-techniques.component.css']
})
export class ErrorTechniquesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void{
  }

}
